'use strict';

var angular = require('angular'),
    Howl = require('howler').Howl;

	
		
Array.prototype.sort2values = function(isFirst){

	var j = this.length-1;
	var temp;
	
	for (var i=0; i<this.length && i<j; i++){
		if (!isFirst(this[i]))
		{
			while(!isFirst(this[j]) && i<j)
				j--;
			var temp = this[i];
			this[i] = this[j];
			this[j] = temp;
		}
	}
};
					
	
	
module.exports = angular.module('agada.services', [])
    .factory('Subjects', ['$http', 'AJAX_DOMAIN_PATH', function ($http, AJAX_DOMAIN_PATH) {//add , $rootscope
        var obj = {};
        var resp_promise;
        var subjects = new Object();

        var arrange_subjects = function (response) {
            if (response.data) {
                subjects = angular.copy(response.data);
                var tempArr = new Array();
                for (var subjectKey in subjects) {
                    tempArr.push(subjects[subjectKey]);
                }
                subjects = tempArr;

                return (subjects);
            }
        };

        obj.query = function () {
            resp_promise = $http.post(AJAX_DOMAIN_PATH + '/api/terms/h_terms/getTree', "").then(
                arrange_subjects,
                function subjectLoadError(response) {
                    console.log("error getting subjects");
                }
            );
        };

        obj.getPromise = function () {
            return resp_promise;
        }

        obj.query();

        obj.getSubjects = function () { return subjects; }
        return obj;

    }])
    .factory('SubjectData', ['$http', 'AJAX_DOMAIN_PATH', function ($http, AJAX_DOMAIN_PATH) {//add , $rootscope
        var obj = {};
        var resp_promise;
        var currentSubject;

        obj.query = function (subjectId) {
            if (subjectId) {
                var data = { 'tid': subjectId };
                resp_promise = $http.post(AJAX_DOMAIN_PATH + '/api/terms/h_terms/selectChildrenAndNodes', JSON.stringify(data)).then(function (response) {
                    if (response) {
                        currentSubject = angular.copy(response.data);
                        return (currentSubject);
                    }
                });
                return resp_promise;
            }
            return "";
        }

        obj.getPromise = function () {
            return resp_promise;
        }

        obj.getCurrentSubject = function () { return currentSubject; }

        obj.query();

        return obj;
    }])
    .factory('AdvSearch', ['$http', 'AJAX_DOMAIN_PATH', function ($http, AJAX_DOMAIN_PATH) {//add , $rootscope
        var obj = {};
        var resp_promise;
        var advSearchData;
        var textToSearch;

        obj.query = function () {
            resp_promise = $http.get(AJAX_DOMAIN_PATH + '/api/advanced_search/advanced_search').then(function (response) {
                if (response) {
                    advSearchData = angular.copy(response.data);
                    return (advSearchData);
                }
            });
            return resp_promise;
        }

        obj.getPromise = function () {
            return resp_promise;
        }

        obj.getAdvSearchData = function () { return advSearchData; }

        obj.query();

        return obj;
    }])
    .factory('Stories', ['$http', '$modal', 'AJAX_DOMAIN_PATH', function ($http, $modal, AJAX_DOMAIN_PATH) {//add , $rootscope
        var obj = {};
        var resp_promise;
        var stories;
        var story;

        obj.query = function () {
            resp_promise = $http.get(AJAX_DOMAIN_PATH + '/api/mainpage/agada_story?parameters[type]=agada_story&parameters[status]=1&page=0&pagesize=40&sort=totalcount&direction=DESC').then(function (response) {
                stories = angular.copy(response.data);
                return (stories);

            }, function () {
                console.log("cannot get stories");
            });
        }

        obj.queryAddStories = function (page, getMore) {
            console.log(page)
            return $http.get(AJAX_DOMAIN_PATH + '/api/mainpage/agada_story?parameters[type]=agada_story&parameters[status]=1&page=' + page + '&pagesize=40&sort=totalcount&direction=DESC').then(function (response) {
                if (response) {
                    if (response.data && response.data.length > 0) {

                        stories = stories.concat(response.data);
                        // stories += angular.copy(response.data);
                        // console.log(stories);
                        // Promise.resolve(stories);
                        return (stories);
                    }
                    getMore.loadMore = false;
                    return undefined;
                }
            }, function () {
                console.log("cannot add stories");
            });

        }


        obj.getPromise = function () {
            return resp_promise;
        }

        obj.getStories = function () { return stories; }


        obj.getStory = function (nid) {
            return $http.post(AJAX_DOMAIN_PATH + '/api/agada_story/agada_story/getNodeDetails', JSON.stringify({ 'nid': parseInt(nid).toString() })).then(function (response) {
                if (response && response.data) {
					if (response.data[0] === false)
						return false;
                    story = angular.copy(response.data);
                    return story;
                }
            })
        }

        obj.query();

        return obj;
    }])
    .factory('SubjectsKids', ['$http', 'AJAX_DOMAIN_PATH', function ($http, AJAX_DOMAIN_PATH) {
        var obj = {};
        var subjects;
        var resp_promise;
        var chosenSubject = { 'name': 'כל הסיפורים', 'tid': '' };
        obj.query = function () {
            resp_promise = $http.post(AJAX_DOMAIN_PATH + '/api/terms/h_terms/getKidsTree', "").then(function (response) {
                if (response && response.data) {
                    subjects = angular.copy(response.data);
                    subjects.unshift({ 'name': 'כל הסיפורים', 'tid': '' });
                    return subjects;
                }
            })
        }

        obj.getPromise = function () {
            return resp_promise;
        }

        obj.getSubjects = function () { return subjects; }

        obj.getChosenSubject = function () { return chosenSubject; }

        obj.setChosenSubject = function (subject) {
            chosenSubject = subject
        }

        obj.query();

        return obj;
    }])
    .factory('StoriesKids', ['$http', '$rootScope', 'AJAX_DOMAIN_PATH', function ($http, $rootScope, AJAX_DOMAIN_PATH) {
        var obj = {};
        var stories;
        var story;
        var total_stories;
        var resp_promise;

        var displayList = false;

        obj.query = function () {
            resp_promise = $http.get(AJAX_DOMAIN_PATH + '/api/mainpage/agada_story?&page=0&pagesize=12&sort=totalcount&direction=DESC&kids=1').then(function (response) {
                if (response && response.data) {
                    stories = angular.copy(response.data).items;
                    total_stories = angular.copy(response.data.total);
                    return stories;
                }
            })
        }

        obj.queryAllStories = function () {
            return $http.get(AJAX_DOMAIN_PATH + '/api/mainpage/agada_story?&page=0&pagesize=200sort=totalcount&direction=DESC&kids=1').then(function (response) {
                if (response && response.data) {
                    stories = angular.copy(response.data.items);
                    $rootScope.finishLoadST = true;
                    return stories;
                }
            })
        }

        obj.queryAddStories = function (page, getMore) {

            return $http.get(AJAX_DOMAIN_PATH + '/api/mainpage/agada_story?&page='+page+'&pagesize=12&sort=totalcount&direction=DESC&kids=1').then(function (response) {
                if (response) {
                    console.log(response)
                    if (response.data && response.data && response.data.items && response.data.items.length > 0) {
                        stories = stories.concat(response.data.items);
                        console.log(stories)
                        return (stories);
                    }
                    getMore.loadMore = false;
                    $rootScope.finishLoadST = true;
                    return undefined;
                }
            }, function () {
                console.log("cannot add stories");
            });

        }

        obj.getPromise = function () {
            return resp_promise;
        }

        obj.getStories = function () { return stories; }

        obj.getTotalStories = function () { return total_stories; }

        obj.getStory = function (nid) {
            return $http.post(AJAX_DOMAIN_PATH + '/api/agada_story/agada_story/getNodeDetails?kids=1', JSON.stringify({ 'nid': parseInt(nid).toString() })).then(function (response) {
                if (response && response.data) {
					if (response.data[0] === false)
						return false;
                    story = angular.copy(response.data);
                    return story;
                }
            })
        }

        obj.getDisplaying = function () { return displayList; }

        obj.setDisplaying = function (disp) {
            displayList = disp;
        }

        obj.query();

        return obj;
    }])
    .factory('Player', ['$window', '$q', function ($window, $q) {
        var Player = function (sound) {
            var self = this;
            this._promise = $q.defer();
            this.howl = new Howl({
                src: [sound],
                onload: function (id, msg) {
                    self._promise.notify('loaded')
                },
                onend: function () {
                    self._promise.notify('ended');
                },
                onloaderror: function (id, msg) {
                    self._promise.notify({ 'error': msg })
                }
            });
        }

        Player.prototype.play = function () {
            this.howl.play();
            this._promise.notify('play');
            return this;
        }

        Player.prototype.pause = function () {
            this.howl.pause();
            this._promise.notify('pasue');
            return this;
        }

        Player.prototype.stop = function () {
            this.howl.pause();
            this._promise.notify('stop');
            return this;
        }

        Player.prototype.destroy = function () {
            this.howl.unload();
            this._promise.notify('unload');
            return this;
        }

        Player.prototype.onStateChange = function (cb) {
            this._promise.promise.then(angular.noop, angular.noop, cb);
            return this;
        }

        Player.prototype.seek = function (per) {
            var seek = this.howl.seek(per * this.howl.duration());
        }

        Player.prototype.getProgress = function () {
            return (((this.howl.seek() / this.howl.duration()) * 100) || 0);
        }

        Player.prototype.getCurrentDuration = function () {
            return this.howl.seek();
        }

        Player.prototype.formatTime = function (secs) {
            var minutes = Math.floor(secs / 60) || 0;
            var seconds = (secs - minutes * 60) || 0;

            return minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
        }

        return Player;
    }])
    .factory('Map', require('./mapService.js'))
    .name;


//////////////////
// WEBPACK FOOTER
// ./public/js/services/index.js
// module id = 87
// module chunks = 0